import { DialogContent } from "@material-ui/core";
import { DialogDeciderActionTypes } from "./ActionSelectorDialog"
import { CreateComplaintDialog } from "./createDialogs/CreateComplaintDialog";
import { CreateFoiDialog } from "./createDialogs/CreateFoiDialog";
import { CreateSarDialog } from "./createDialogs/CreateSarDialog";

export const DialogCreateActionDecider: React.FC<{
  item: any;
  actionDialog: DialogDeciderActionTypes;
}> = ({ item, actionDialog }) => {
  let renderCreateActionDalog;
  switch (actionDialog.action) {
    case "FOI":
      renderCreateActionDalog = (
        <>
          <CreateFoiDialog peId={item.id} />
        </>
      );
      break;
    case "Complaint":
      renderCreateActionDalog = (
        <>
          <CreateComplaintDialog peId={item.id} />
        </>
      );
      break;
    case "SAR":
      renderCreateActionDalog = (
        <>
          <CreateSarDialog peId={item.id} />
        </>
      );
      break;
    default:
      renderCreateActionDalog = (
        <DialogContent>Create Dialog action not supported</DialogContent>
      );
  }

  return renderCreateActionDalog;
};
